/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./pageBuilder/bootstrap');

window.jQuery.fn.scrollTo = function(elem, speed) {
    jQuery(this).animate({
        scrollTop:  jQuery(this).scrollTop() - jQuery(this).offset().top + $(elem).offset().top
    }, speed == null ? 1000 : speed);
    return this;
};

window.axios = require('axios');
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};

let Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.component('image-cropper', require('./imageCropper/components/ImageCropper.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import VueAxios from 'vue-axios';

Vue.use(VueAxios, window.axios);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

// Optionally install the BootstrapVue icon components plugin
Vue.use(BootstrapVueIcons)

Vue.config.productionTip = true;
Vue.config.devtools = true;
Vue.config.debug = process.env.APP_DEBUG;

if (document.getElementById('app')) {
    const app = new Vue({
        el: '#app',
    });
}
